import {Pipe, PipeTransform} from "@angular/core";
import {WORK_ORDER_STATUS} from "../../core/constants";

@Pipe({
    name: 'workOrderStatusPipe'
})
export class WorkOrderStatusPipe implements PipeTransform {

        transform(status: number): string {

            switch (status) {

                case WORK_ORDER_STATUS.PRICING:
                    return "Pricing";
                case WORK_ORDER_STATUS.WAITING_FOR_USER: // says ready to schedule for users perspective
                    return "Ready";
                case WORK_ORDER_STATUS.READY_TO_SCHEDULE: // says scheduled for users perspective
                    return "Scheduled";
                case WORK_ORDER_STATUS.PENDING_APPROVAL:
                    return "Approval";
                case WORK_ORDER_STATUS.PENDING_PARTNER:
                    return "Partner";
                case WORK_ORDER_STATUS.PARTS_ORDERING:
                    return "Parts Ordering";
                case WORK_ORDER_STATUS.REVIEW_REQUIRED:
                    return "Review";
                case WORK_ORDER_STATUS.CANCELLED:
                    return "Cancelled";
                case WORK_ORDER_STATUS.SCHEDULED:
                    return "Scheduled";
                case WORK_ORDER_STATUS.ENROUTE:
                    return "En route";
                case WORK_ORDER_STATUS.RESCHEDULE_NEEDED:
                    return "Reschedule";
                case WORK_ORDER_STATUS.ON_HOLD:
                    return "On Hold";
                case WORK_ORDER_STATUS.COMPLETE:
                    return "Complete";
                case WORK_ORDER_STATUS.SAVED:
                    return "Saved";
                case WORK_ORDER_STATUS.WORKING:
                    return "Working";
                default:
                    return "n/a";
            }
        } // transform()

} // JobRequestStatusPipe
